import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from '../../models/api-resource.interface';
import { SavedFilter } from './filter.interface';

export class FilterService {
   async getFilters(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<SavedFilter>>>('/filters', { params: { ...query } });
      return response.data;
   }

   async getAllFilters(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<SavedFilter>>>('/filters/all', { params: { ...query } });
      return response.data;
   }

   async getFilter(filterId: number) {
      const response = await http.get<ApiResource<SavedFilter>>(`/filters/${filterId}`);
      return response.data;
   }

   async postFilter(filter: SavedFilter) {
      const response = await http.post<ApiResource<SavedFilter>>(`/filters`, filter, { params: { include: 'user' } });
      return response.data;
   }

   async putFilter(filter: SavedFilter) {
      const response = await http.put<ApiResource<SavedFilter>>(`/filters/${filter.id}`, filter, { params: { include: 'user' } });
      return response.data;
   }

   async deleteFilter(filter: SavedFilter) {
      await http.delete(`/filters/${filter.id}`);
   }

   async restoreFilter(filter: SavedFilter) {
      await http.patch(`/filters/${filter.id}/restore`);
   }
}
